var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"footer_logo",attrs:{"tag":"a","to":"/"}},[_c('img',{attrs:{"src":"/logo/logo-sushiset-white.svg","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }